'use client';

import { IconButton } from '@yanolja-rnd/nol-design-system';
import { IcArrowlessFill, IcArrowmoreFill } from '@yanolja-rnd/nol-icons';
import { useImpressionLog } from '@/app/_shared/hooks/use-impression-log';

interface CategoryOverviewButtonProps {
  isOpen: boolean;
  onImpression: () => void;
  onButtonClick: () => void;
}

export const CategoryOverviewButton = ({ isOpen, onImpression, onButtonClick }: CategoryOverviewButtonProps) => {
  const ref = useImpressionLog(onImpression);

  return (
    <div
      ref={ref}
      className="absolute right-0 top-0 z-[1] my-12 flex h-41 w-56 items-center justify-center"
      style={{
        background: 'linear-gradient(to right, transparent 0px, white 12px)',
      }}
      onClick={onButtonClick}>
      <IconButton theme="ghost" icon={isOpen ? <IcArrowlessFill /> : <IcArrowmoreFill />} size="small" />
    </div>
  );
};
